export enum WideScreenMenuBehavior {
  AllClosedOnLoad = 'all-closed-on-load',
  AllOpenOnLoad = 'all-open-on-load',
  OnlyOneOpen = 'only-one-open',
}
